export const getNestedPropertyValue = (obj: any, path: string) => {
  return path.split('.').reduce((acc, key) => acc?.[key] ?? '', obj);
};
